<template>
  <ak-notification type="info" epic>
    <h5>
      <ak-icon type="iphone" />
      REMEMBER TO ALLOW TO OPT-OUT
    </h5>
    <p>
      Recipients can stop SMS messages by responding with the word "STOP".
      Remind your recipients that they can opt out by ending your message with a
      sentence such as:
    </p>
    <ak-tag color="white"> Reply STOP to opt out </ak-tag>
  </ak-notification>
</template>

<script>
import { defineComponent } from 'vue'
import Notification from '@akerolabs/akero-vue/src/components/notification/Notification.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import Tag from '@akerolabs/akero-vue/src/components/tag/Tag.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-sms-templates-reply-stop></ak-sms-templates-reply-stop>
   */
  name: 'AkSmsTemplatesReplyStop',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Notification.name]: Notification,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
  },

  /**
   * @type {Boolean}
   * @description This prevents all element attributes that are not
   * defined in the props object from being applied to the rendered
   * component root element, the exception to this is "class" all
   * of the given classes would be merged with the component
   * defined ones.
   */
  inheritAttrs: false,
})
</script>
